import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {NgForm, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {PolicyContractVersionListComponent} from './components';
import {
  AppConfigService,
  BackendError,
  BusinessReportService,
  CompanyService,
  CompanySimpleDto,
  ConfirmDialogComponent,
  CustomValidators,
  DictionaryBaseDto,
  DictionaryBaseService,
  DictionaryDto,
  DictionaryService,
  DocumentService,
  FormDialogComponent,
  GrowlService,
  IdDto,
  InquiryService,
  LoggedUserService,
  MasterPolicyContractBaseDto,
  MasterPolicyContractDto,
  MasterPolicyContractService,
  PolicyContractBaseDto,
  PolicyContractCoInsurerCompanyDto,
  PolicyContractDto,
  PolicyContractService,
  PolicyContractSubinsuredCompanyDto,
  PolicyContractVersionDto,
  PolicyContractVersionService,
  RelatedObject,
  RouterService,
  TemplateService,
  TemplateSimpleDto,
} from '../../bonding_shared';
import {PolicyContractViewSection, PolicyContractViewService} from './services/policy-contract-view.service';
import {DetailsView} from '../../bonding_shared/components/details-view/details-view';
import {Button} from '../../bonding_shared/components/details-view/button';
import {
  BusinessObjectType,
  ContactNoteElementaryRight,
  FrontingType,
  POLICY_CONTRACT_REQUEST_OR_TERMINATION_REQUEST_STATUSES,
  PolicyContractType,
  GciVersionTypes,
  PolicyContractVersionStatus,
  PolicyElementaryRight,
  RepoDocumentElementaryRight,
  ServiceContactElementaryRight,
  ServiceNoteElementaryRight,
  TaskType,
  PolicyContractSubType,
} from '../../bonding_shared/model/dictionary-ids';
import {CrPolicyProductComponent} from './components/products/cr-policy-product.component';
import {CaptiveProductComponent, ExcessOfLossProductComponent, TopUpProductComponent} from './components/products/cr';
import {HttpParams} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {
  IPasteFromExcelColumnConfig,
  IPasteFromExcelConfig,
} from '../../bonding_shared/components/aku-table/services/paste-from-excel.service';

@Component({
  selector: 'policy-contract-details',
  templateUrl: './policy-contract-details.component.pug',
})
export class PolicyContractDetailsComponent extends DetailsView implements OnInit {
  @ViewChild('rejectPolicyRequestDialog', {static: true}) rejectPolicyRequestDialog: FormDialogComponent;
  @ViewChild('policyResignationDialog', {static: true}) policyResignationDialog: FormDialogComponent;
  @ViewChild('addToSplitDialog', {static: true}) addToSplitDialog: FormDialogComponent;

  public readonly BusinessObjectType = BusinessObjectType;
  public readonly PolicyContractViewService = PolicyContractViewService;
  public readonly PolicyContractVersionStatus = PolicyContractVersionStatus;
  public readonly ContactNoteElementaryRight = ContactNoteElementaryRight;
  public readonly ServiceContactElementaryRight = ServiceContactElementaryRight;
  readonly ServiceNoteElementaryRight = ServiceNoteElementaryRight;
  public readonly RepoDocumentElementaryRight = RepoDocumentElementaryRight;
  public readonly PolicyElementaryRight = PolicyElementaryRight;

  @ViewChild('ngForm', {static: true}) ngForm: NgForm;

  _policyContractVersionList: PolicyContractVersionListComponent;

  public triggerComponent: string = 'policyContractDetails';
  @ViewChild(PolicyContractVersionListComponent)
  set policyContractVersionList(policyContractVersionList: PolicyContractVersionListComponent) {
    this._policyContractVersionList = policyContractVersionList;
  }

  get policyContractVersionList(): PolicyContractVersionListComponent {
    return this._policyContractVersionList;
  }

  // called in ??
  @ViewChild(ConfirmDialogComponent, {static: true}) confirmDialog: ConfirmDialogComponent;

  @ViewChild('topUpProductComponent', {static: true}) topUpProductComponent: TopUpProductComponent;
  // Excess of loss and Excess of loss partner
  @ViewChild('excessOfLossProductComponent', {static: true}) excessOfLossProductComponent: ExcessOfLossProductComponent;
  @ViewChild('captiveProductComponent', {static: true}) captiveProductComponent: CaptiveProductComponent;

  @ViewChild('crPolicyProductComponent', {static: true}) crPolicyProductComponent: CrPolicyProductComponent;

  serverErrors: BackendError;

  public selectedPolicyContractVersion: PolicyContractVersionDto = <PolicyContractVersionDto>{};
  masterPolicyContract: MasterPolicyContractDto;
  previousStatus: DictionaryBaseDto;

  self = this;

  showErrors = false;
  isCreatingNewPolicyYear = false;

  policyContractTypeSet: boolean;
  versionListReady: boolean;

  coInsuredsTempData: CopyPastedTurnoverData[] = [];

  viewSection = PolicyContractViewSection;
  isDuplicateIdExists: boolean = false;

  dropButtons: {
    newPolicyVersionButton: Button;
    newPolicyYearButton: Button;
    newPolicyClosingVersion: Button;
    newPolicyReplaceVersion: Button;
  } = {
    newPolicyVersionButton: new Button(
      'common.button.newVersion',
      this.onCreateNewVersion.bind(this),
      true,
      true,
      'calendar'
    ),
    newPolicyYearButton: new Button(
      'common.button.newPolicyYear',
      this.onCreateNewPolicyYear.bind(this),
      true,
      true,
      'calendar'
    ),
    newPolicyClosingVersion: new Button(
      'common.button.newClosingVersion',
      this.onCreateNewClosingVersion.bind(this),
      true,
      true,
      'calendar'
    ),
    newPolicyReplaceVersion: new Button(
      'common.button.newReplaceVersion',
      this.onCreateNewReplaceVersion.bind(this),
      true,
      true,
      'calendar'
    ),
  };
  newRenewalInquiryHidden = true;
  changeState_flag = false;

  credendoAnyNewActionPossible_flag = false;

  termination_flag = false;

  PolicyContractType = PolicyContractType;
  PolicyContractSubType = PolicyContractSubType;
  private _presentationMode = false;

  dictionarySelectors: DictionaryBaseDto[] = [];

  wordingTemplates: TemplateSimpleDto[] = [];

  pasteCountriesFromExcelConfigs: IPasteFromExcelConfig[] = [
    {
      columns: [
        <IPasteFromExcelColumnConfig>{
          type: 'text',
          property: 'insuredName',
        },
        <IPasteFromExcelColumnConfig>{
          type: 'text',
          property: 'insuredCountry',
        },
        <IPasteFromExcelColumnConfig>{
          type: 'number',
          property: 'insuredCesarId',
        },
        <IPasteFromExcelColumnConfig>{
          type: 'dictionary',
          property: 'taxCountry',
          dictionary: 'Country',
        },
        <IPasteFromExcelColumnConfig>{
          type: 'number',
          property: 'domestic',
        },
        <IPasteFromExcelColumnConfig>{
          type: 'number',
          property: 'export',
        },
        <IPasteFromExcelColumnConfig>{
          type: 'number',
          property: 'total',
        },
      ],
    },
  ];

  constructor(
    protected _companyService: CompanyService,
    protected policyContractService: PolicyContractService,
    protected loggedUserService: LoggedUserService,
    public policyContractVersionService: PolicyContractVersionService,
    protected masterPolicyContractService: MasterPolicyContractService,
    protected route: ActivatedRoute,
    public routerService: RouterService,
    protected templateService: TemplateService,
    protected policyContractViewService: PolicyContractViewService,
    protected translateService: TranslateService,
    protected growlService: GrowlService,
    protected cd: ChangeDetectorRef,
    public appService: AppConfigService,
    protected inquiryService: InquiryService,
    protected dictionaryBaseService: DictionaryBaseService,
    private documentService: DocumentService,
    protected businessReportService: BusinessReportService,
    private dictionaryService: DictionaryService
  ) {
    super(growlService);

    this.hideButtons(false);
    this.deleteButton.hidden = true; // No logic for deleting policy on backend
    this.newVersionButton.hidden = true;

    this.selectorNameList = [RelatedObject.CLIENT];
    this.initializeSelectorEmitters(true);
  }

  get readonly() {
    return this.policyContractViewService.readonly;
  }

  set readonly(readonly) {
    this.policyContractViewService.readonly = readonly;
    this.handleButtonsWithParam(readonly);
    if (!readonly) {
      this.policyContractViewService.reportingPeriodsEditable = false;
    }
  }

  handleButtonsWithParam(readonlyParam: boolean) {
    const totallyReadonly = readonlyParam && !this.policyContractViewService.reportingPeriodsEditable;
    const editionPossible = this.versionEditable();
    const hideSaveCancelButtons = totallyReadonly || !editionPossible;
    this.saveButton.hidden = hideSaveCancelButtons;
    this.cancelButton.hidden = hideSaveCancelButtons;
    this.uploadToSplitButton.hidden = hideSaveCancelButtons;
    this.editButton.hidden = !(totallyReadonly && editionPossible);
  }

  ngOnInit() {
    this.readOnlyMode = true;
    this.route.params.subscribe((params) => this.initializeView(params));
  }

  initializeView(params: Params) {
    this.hideButtons(true);
    this.form = this.ngForm.form;
    const id = +params['id'];
    if (this.selectedPolicyContractVersion && id === this.selectedPolicyContractVersion.id) {
      return;
    }
    this.versionListReady = false;
    const clientId = +params['clientId'];
    const offerVersionId = +params['offerVersionId'];
    // prettier-ignore
    console.log('initialize view: contract-details id = ' + id + ', clientId = ' + clientId + ', offerVersionId = ' + offerVersionId);
    this.initializeContract(id, clientId, offerVersionId);
    this.form.addControl(
      'insureds',
      new UntypedFormGroup(
        {
          premiumInstalments: new UntypedFormControl({
            value: this.selectedPolicyContractVersion.premiumInstalments,
            disabled: this.premiumInstalmentsCheckboxDisabled(),
          }),
          premiumInstalmentCalendar: new UntypedFormControl(
            this.selectedPolicyContractVersion.premiumInstalementCalendar
          ),
          subinsured: new UntypedFormControl(this.selectedPolicyContractVersion.subinsured),
        },
        CustomValidators.minPremiumFixedEqualsPremiumInstalmentCalendarSum
      )
    );

    this._presentationMode = params['presentationMode'];
  }

  private premiumInstalmentsCheckboxDisabled() {
    return (
      this.selectedPolicyContractVersion &&
      this.selectedPolicyContractVersion.contractType &&
      this.policyContractViewService.isSectionVisible(
        this.selectedPolicyContractVersion.contractType.id,
        PolicyContractViewSection.PREMIUM__PREMIUM_INSTALMENTS_DISABLED,
        false
      )
    );
  }

  // setPolicyContractVersion (9 triggers)
  policyVersionInitialized() {
    const ft = this.selectedPolicyContractVersion.frontingType;
    this.addOrRemoveRequiredControl(
      ft && ft.id === FrontingType.FRONTING_ASSUMED,
      'frontingTreaty',
      this.selectedPolicyContractVersion.frontingTreaty
    );

    const gr = <UntypedFormGroup>this.form.get('insureds');
    if (!this.isSectionVisible(this.viewSection.PREMIUM__MIN_PREMIUM_FIXED, true)) {
      if (gr) {
        gr.removeControl('minPremiumFixed');
      }
    } else {
      gr.setControl(
        'premiumInstalments',
        new UntypedFormControl({
          value: this.selectedPolicyContractVersion.premiumInstalments,
          disabled: this.premiumInstalmentsCheckboxDisabled(),
        })
      );
    }
  }

  private addOrRemoveRequiredControl(condition: boolean, controlName: string, value?: any) {
    if (condition && !this.form.contains(controlName)) {
      this.form.addControl(controlName, new UntypedFormControl(value ? value : '', Validators.required));
    }
    if (!condition && this.form.contains(controlName)) {
      this.form.removeControl(controlName);
    }
  }

  // initializeView
  // onCancel
  initializeContract(contractVersionId: number, clientId: number, offerVersionId: number) {
    this.selectedPolicyContractVersion = <PolicyContractVersionDto>{};
    console.log(this.selectedPolicyContractVersion);
    if (contractVersionId > 0) {
      this.policyContractTypeSet = true;
      this.policyContractVersionService.getPolicyContractVersion(contractVersionId).subscribe(
        (policyContractVersion) => {
          this.setPolicyContractVersion(policyContractVersion, false);
          this.loadWordingTemplates();
        },
        () => console.log('Something went wrong on policyContractVersionService.getPolicyContractVersion')
      );
    } else {
      if (clientId && clientId > 0) {
        this.initializeCompany(clientId);
      }
      if (offerVersionId && offerVersionId > 0) {
      }
      this.policyContractTypeSet = false;
      this.selectedPolicyContractVersion.policyContract = <PolicyContractBaseDto>{};
      this.selectedPolicyContractVersion.policyContract.masterPolicyContract = <MasterPolicyContractBaseDto>{};
      this.selectedPolicyContractVersion.policyContract.policyYear = 1;
      this.selectedPolicyContractVersion.policyContract.policySubYear = 1;
      this.selectedPolicyContractVersion.policyContract.policySubYears = 1;
      this.selectedPolicyContractVersion.subinsured = [];
      this.selectedPolicyContractVersion.businessUnit = this.loggedUserService.getLoggedUserData().businessUnit;
      this.readonly = false;
      this.cd.reattach();
    }
  }

  // initializeContract if there was clientId
  initializeCompany(clientId: number) {
    this._companyService.getCompanySimple(clientId).subscribe((company) => {
      this.selectedPolicyContractVersion.client = company;
    });
  }

  /* Policy contract type set from the GUI
    1. Sets the policyContractTypeSet flags
    2. Calls setPolicyContractVersion*/
  onSetPolicyContractType(policyContractType: DictionaryDto) {
    if (!this.policyContractTypeSet) {
      this.policyContractTypeSet = true;
      this.handleClientCompanyType(policyContractType);
    }
    // Auto-select "TopUp 2014" as default GCI when product is "Top Up Prime"
    if (policyContractType.id === PolicyContractType.TOP_UP) {
      this.dictionaryService.getDictionary('PolicyContractType').subscribe((types) => {
        const gciVersiontopUp = types.find((t) => t.id === PolicyContractType.TOP_UP);
        const topUp = gciVersiontopUp.relatedDictionaries?.['GlobalConditionsOfInsurance']?.find(
          (gci) => gci.id === GciVersionTypes.TOPUP_2014
        );
        if (topUp) {
          this.selectedPolicyContractVersion.globalConditionsOfInsurance = topUp;
        }
      });
    }
  }

  getInitialContractVersion(policyContractTypeId: number) {
    this.policyContractService
      .getInitialContractVersion(
        this.selectedPolicyContractVersion.businessUnit.id,
        this.selectedPolicyContractVersion.client.address.country.id,
        policyContractTypeId
      )
      .subscribe((policyContractVersion) => this.setPolicyContractVersion(policyContractVersion, true));
  }

  handleClientCompanyType(policyContractType: DictionaryBaseDto) {
    this.getInitialContractVersion(policyContractType.id);
  }

  // onSave
  // onSelectPolicyContract
  // afterNewAnnex
  // afterNewPolicyYear
  setPolicyContract(policyContract: PolicyContractDto, reloadPolicyVersion: boolean) {
    console.log('<<<<<<<<< set Contract >>>>>>>>> ', policyContract);
    if (this.selectedPolicyContractVersion.policyContract.masterPolicyContract.id) {
      this.masterPolicyContractService
        .getMasterPolicyContract(this.selectedPolicyContractVersion.policyContract.masterPolicyContract.id)
        .subscribe((masterPolicy) => (this.masterPolicyContract = masterPolicy));
    }
    this.updateButtons();
    console.log('<//////// set Contract >>>>>>>>>');
  }

  // initializeContract
  // onSetPolicyContractType
  // onCreateNewVersion
  // onCreateNewPolicyYear
  // onSave
  // onCancel
  // onSelectPolicyContractVersion
  // afterNewAnnex
  // afterNewPolicYear
  setPolicyContractVersion(policyContractVersion: PolicyContractVersionDto, isTemplate?: boolean) {
    console.log('<<<<<<<<< set Contract Version >>>>>>>>> ', policyContractVersion);
    this.serverErrors = null;
    this.policyContractTypeSet = true;

    this.readonly = !!policyContractVersion.id;

    if (isTemplate) {
      policyContractVersion = Object.assign(this.selectedPolicyContractVersion, policyContractVersion);
    } else {
      policyContractVersion = Object.assign(<PolicyContractVersionDto>{}, policyContractVersion);
    }

    this.selectedPolicyContractVersion = policyContractVersion;
    this.previousStatus = policyContractVersion.status;

    if (this.policyContractVersionList) {
      this.policyContractVersionList.selectedPolicyContractVersion = policyContractVersion;
    }

    if (!this.masterPolicyContract && this.selectedPolicyContractVersion.policyContract.masterPolicyContract.id) {
      this.masterPolicyContractService
        .getMasterPolicyContract(this.selectedPolicyContractVersion.policyContract.masterPolicyContract.id)
        .subscribe((masterPolicy) => (this.masterPolicyContract = masterPolicy));
    }
    if (policyContractVersion.warnings) {
      this.handleServerError(policyContractVersion.warnings);
    }
    this.inProgress = false;
    this.updateButtons();
    this.policyVersionInitialized();

    this.updateForm();

    this.cd.reattach();
    console.log('<//////// set Contract Version >>>>>>>>>');
  }

  private updateForm() {
    if (this.selectedPolicyContractVersion.reinsuranceMode) {
      setTimeout(
        () => this.form.get('reinsuranceMode').setValue(this.selectedPolicyContractVersion.reinsuranceMode),
        0
      );
    }
    if (this.selectedPolicyContractVersion.frontingTreaty) {
      this.form.get('frontingTreaty').setValue(this.selectedPolicyContractVersion.frontingTreaty);
    }
    if (this.form.get('insuredTurnoverDomestic')) {
      this.form.get('insuredTurnoverDomestic').setValue(this.selectedPolicyContractVersion.insuredTurnoverDomestic);
      this.form.get('insuredTurnoverDomestic').updateValueAndValidity();
    }
    if (this.form.get('insuredTurnoverExport')) {
      this.form.get('insuredTurnoverExport').setValue(this.selectedPolicyContractVersion.insuredTurnoverExport);
      this.form.get('insuredTurnoverExport').updateValueAndValidity();
    }
    if (this.form.get('insuredTurnover')) {
      this.form.get('insuredTurnover').setValue(this.selectedPolicyContractVersion.insuredTurnover);
      this.form.get('insuredTurnover').updateValueAndValidity();
    }
    if (this.form.get('clientTurnoverDomestic')) {
      this.form.get('clientTurnoverDomestic').setValue(this.selectedPolicyContractVersion.clientTurnoverDomestic);
      this.form.get('clientTurnoverDomestic').updateValueAndValidity();
    }
    if (this.form.get('clientTurnoverExport')) {
      this.form.get('clientTurnoverExport').setValue(this.selectedPolicyContractVersion.clientTurnoverExport);
      this.form.get('clientTurnoverExport').updateValueAndValidity();
    }
    if (this.form.get('clientTurnover')) {
      this.form.get('clientTurnover').setValue(this.selectedPolicyContractVersion.clientTurnover);
      this.form.get('clientTurnover').updateValueAndValidity();
    }
  }

  selectedPCVInStatus(status: PolicyContractVersionStatus): boolean {
    return (
      this.selectedPolicyContractVersion &&
      this.selectedPolicyContractVersion.id > 0 &&
      this.selectedPolicyContractVersion.status &&
      this.selectedPolicyContractVersion.status.id === status
    );
  }

  get selectedPCVIsLastVersion(): boolean {
    return this.selectedPolicyContractVersion && this.selectedPolicyContractVersion.last;
  }

  selectedPCVIsLastPolicyYear() {
    return this.selectedPolicyContractVersion && this.selectedPolicyContractVersion.policyContract.last;
  }

  get changeStatePossible() {
    return this.changeState_flag;
  }

  private changeStateAvailable(): boolean {
    if (!this.selectedPolicyContractVersion) {
      return false;
    }
    if (this.lastVersionRejected()) {
      return this.selectedPolicyContractVersion.lastActivated;
    } else {
      return this.selectedPCVIsLastVersion;
    }
  }

  updateButtons() {
    const newVersionHidden =
      !this.selectedPolicyContractVersion.id ||
      !this.selectedPolicyContractVersion.lastActivated ||
      this.selectedPolicyContractVersion.status.id === PolicyContractVersionStatus.ACTIVATED_LOCKED ||
      (!this.selectedPolicyContractVersion.last && this.lastVersionCanBeActivated());

    const newYearHidden =
      !this.selectedPolicyContractVersion.id ||
      !(
        this.selectedPCVIsLastPolicyYear() &&
        ((this.selectedPolicyContractVersion.lastActivated && !this.lastVersionCanBeActivated()) ||
          this.selectedVersionIsOnlyAndCanBeActivated())
      ) ||
      this.isCreatingNewPolicyYear ||
      this.selectedPolicyContractVersion.status.id === PolicyContractVersionStatus.ACTIVATED_LOCKED;

    const terminatedStatus = this.inStatusTerminated;
    this.dropButtons.newPolicyVersionButton.disabled = newVersionHidden;
    this.dropButtons.newPolicyReplaceVersion.disabled = newVersionHidden;
    this.dropButtons.newPolicyClosingVersion.disabled = newVersionHidden || terminatedStatus;
    this.dropButtons.newPolicyVersionButton.hidden = newVersionHidden;
    this.dropButtons.newPolicyClosingVersion.hidden = newVersionHidden || terminatedStatus;
    this.dropButtons.newPolicyReplaceVersion.hidden = newVersionHidden;

    this.dropButtons.newPolicyYearButton.disabled = newYearHidden;
    this.dropButtons.newPolicyYearButton.hidden = newYearHidden;
    this.newRenewalInquiryHidden = newYearHidden;

    this.credendoAnyNewActionPossible_flag = !(newVersionHidden && newYearHidden);
    this.changeState_flag = this.changeStateAvailable();

    this.calculateCanBeTerminated();

    this.handleButtonsWithParam(this.readonly);
  }

  private lastVersionCanBeActivated() {
    if (!this.selectedPolicyContractVersion || !this.selectedPolicyContractVersion.policyContract) {
      return false;
    }
    const lvs = this.selectedPolicyContractVersion.policyContract.lastVersionStatus;
    return (
      lvs &&
      [
        PolicyContractVersionStatus.REQUEST,
        PolicyContractVersionStatus.REQUEST_ACCEPTED,
        PolicyContractVersionStatus.ISSUED,
        PolicyContractVersionStatus.PROLONGATION_REQUEST,
        PolicyContractVersionStatus.PROLONGATION_REQUEST_EXTRA_RIGHTS,
        PolicyContractVersionStatus.PROLONGATION_REQUEST_ACCEPTED,
        PolicyContractVersionStatus.TERMINATION_REQUEST,
        PolicyContractVersionStatus.TERMINATION_REQUEST_ACCEPTED,
      ].includes(lvs.id)
    );
  }

  private lastVersionRejected() {
    if (!this.selectedPolicyContractVersion || !this.selectedPolicyContractVersion.policyContract) {
      return false;
    }
    const lvs = this.selectedPolicyContractVersion.policyContract.lastVersionStatus;
    return (
      lvs &&
      [
        PolicyContractVersionStatus.REQUEST_REJECTED,
        PolicyContractVersionStatus.PROLONGATION_REQUEST_REJECTED,
        PolicyContractVersionStatus.USER_ERROR,
        PolicyContractVersionStatus.TERMINATION_REJECTED,
        PolicyContractVersionStatus.VERSION_REPLACED,
      ].includes(lvs.id)
    );
  }

  private selectedVersionIsOnlyAndCanBeActivated() {
    const svs = this.selectedPolicyContractVersion.status;
    // (first && last) => one and only
    return (
      this.selectedPolicyContractVersion.last && // last
      this.selectedPolicyContractVersion.versionNumber === 1 && // first
      svs &&
      [
        PolicyContractVersionStatus.REQUEST, // proper status
        PolicyContractVersionStatus.REQUEST_ACCEPTED,
        PolicyContractVersionStatus.ISSUED,
        PolicyContractVersionStatus.PROLONGATION_REQUEST,
        PolicyContractVersionStatus.PROLONGATION_REQUEST_EXTRA_RIGHTS,
        PolicyContractVersionStatus.PROLONGATION_REQUEST_ACCEPTED,
        // no PolicyContractVersionStatus.TERMINATION_REQUEST
        // => version with this status have to have predecesor
      ].includes(svs.id)
    );
  }

  onCreateNewVersion() {
    this.versionListReady = false;
    this.inProgress = true;
    this.policyContractService
      .getPolicyContractAnnexTemplate(this.selectedPolicyContractVersion.policyContract.id)
      .subscribe(
        (policyContractVersion) => {
          this._presentationMode = false;
          this.setPolicyContractVersion(policyContractVersion);
        },
        (error) => {
          this.handleServerError(error);
        },
        () => this.afterNewAnnex()
      );
  }

  // GUI podpięte pod buttton new version
  onCreateNewClosingVersion() {
    this.termination();
  }

  onCreateNewReplaceVersion() {
    console.log('Replace policy contract: ' + this.selectedPolicyContractVersion.policyContract.id);
    this.versionListReady = false;
    this.inProgress = true;
    this.policyContractService
      .getPolicyContractReplaceAnnexTemplate(this.selectedPolicyContractVersion.policyContract.id)
      .subscribe(
        (policyContractVersion) => {
          this.setPolicyContractVersion(policyContractVersion);
        },
        (error) => {
          this.handleServerError(error);
        },
        () => this.afterNewAnnex()
      );
  }

  onCreateNewPolicyYear() {
    this.versionListReady = false;
    this.isCreatingNewPolicyYear = true;
    this.inProgress = true;
    this.policyContractService.getNewPolicyYearTemplate(this.selectedPolicyContractVersion.policyContract.id).subscribe(
      (policyContractVersion) => {
        this.setPolicyContractVersion(policyContractVersion);
      },
      (error) => {
        this.handleServerError(error);
        this.isCreatingNewPolicyYear = false;
      },
      () => {
        this.inProgress = false;
        this.afterNewPolicyYear();
      }
    );
  }

  // do inquiry details z createRenewalInquiry
  createNewRenewalInquiry() {
    this.inProgress = true;
    this.inquiryService.createRenewalInquiry(this.selectedPolicyContractVersion.id).subscribe(
      (inquiryVersionId) => this.routerService.toPolicyInquiryDetails(inquiryVersionId),
      (error) => this.handleServerError(error),
      () => (this.inProgress = false)
    );
  }

  afterPolicyContractSaved(policyContract: PolicyContractDto) {
    console.log('##### contract version saved id = ' + policyContract.id + 'contract = ', policyContract);
    this.showSavedMsg();
    this.routerService.toPolicyContractDetails(this.selectedPolicyContractVersion.id);
  }

  override afterExclusiveStateTransition(object: PolicyContractVersionDto) {
    this.showSavedMsg();
    this.setPolicyContractVersion(object);
  }

  afterNewAnnex() {
    this.setPolicyContractVersion(this.selectedPolicyContractVersion);
    this.setPolicyContract(<PolicyContractDto>this.selectedPolicyContractVersion.policyContract, false);

    this.isCreatingNewPolicyYear = false;

    this.readonly = false;
  }

  afterNewPolicyYear() {
    this.setPolicyContractVersion(this.selectedPolicyContractVersion);
    this.setPolicyContract(<PolicyContractDto>this.selectedPolicyContractVersion.policyContract, false);
    this.isCreatingNewPolicyYear = true;
    this.readonly = false;
  }

  lifecycleSave() {
    this.onSave();
  }

  onSave(): void {
    this.policyContractViewService.reportingPeriodsEditable = false;
    this.inProgress = true;
    this.showErrors = false;
    this.updateForm();
    if (!this.form.valid) {
      this.showErrors = true;
      this.selectedPolicyContractVersion.status = this.previousStatus;
      this.showFormError();
      Object.keys(this.form.controls).map((key) => {
        if (this.form.controls[key].invalid) {
          console.warn('Invalid control key: ', key);
          console.warn('Invalid control errors: ', this.form.controls[key].errors);
          console.warn('Invalid control value: ', this.form.controls[key].value);
        }
      });
      return;
    }
    this.serverErrors = null;
    console.log('Save: id', this.selectedPolicyContractVersion.id, this.selectedPolicyContractVersion);
    this.updateModel();

    this.policyContractVersionService.savePolicyContractVersion(this.selectedPolicyContractVersion).subscribe({
      next: (contractVersion) => this.setPolicyContractVersion(contractVersion),
      error: (error) => this.handleServerError(error),
      complete: () => {
        this.policyContractService
          .getPolicyContract(this.selectedPolicyContractVersion.policyContract.id)
          .subscribe((policyContract) => {
            this.setPolicyContract(policyContract, false);
            this.afterPolicyContractSaved(policyContract);
            this.isCreatingNewPolicyYear = false;
            this._presentationMode = true;
            this.readOnlyMode = true;
            this.updateButtons();
          });
      },
    });
  }

  showSavedMsg() {
    this.growlService.notice('Policy is saved.');
    this.inProgress = false;
    this.updateButtons();
  }

  showFormError() {
    this.growlService.error('The form has errors!');
    this.inProgress = false;
    this.updateButtons();
  }

  onCancel(): void {
    this.policyContractViewService.reportingPeriodsEditable = false;
    this.cd.detach();
    super.onCancel();
    this.isCreatingNewPolicyYear = false;
    this.updateButtons();
    this.policyContractTypeSet = +this.route.snapshot.params['id'] !== 0;
    if (this.selectedPolicyContractVersion.id && this.selectedPolicyContractVersion.id > 0) {
      this.policyContractVersionService
        .getPolicyContractVersion(this.selectedPolicyContractVersion.id)
        .subscribe((policyContractVersion) => this.setPolicyContractVersion(policyContractVersion));
    } else {
      this.policyContractTypeSet = false;
      this.initializeContract(
        this.route.snapshot.params['id'],
        this.route.snapshot.params['clientId'],
        this.route.snapshot.params['offerVersionId']
      );
    }
  }

  onSelectPolicyContractVersion(policyContractVersion: PolicyContractVersionDto) {
    this.policyContractVersionService.getPolicyContractVersion(policyContractVersion.id).subscribe((pcv) => {
      this.setPolicyContractVersion(pcv);
      this.routerService.toPolicyContractDetails(this.selectedPolicyContractVersion.id);
    });
  }

  onSelectPolicyContract(policyContract: PolicyContractBaseDto, selectLastPolicyContractVersion?: boolean) {
    console.log('onSelectPolicyContract :: id = ' + policyContract.id);
    this.policyContractService.getPolicyContract(policyContract.id).subscribe((pc) => {
      console.log('onSelectPolicyContract ::', pc);
      this.setPolicyContract(pc, true);
      this.isCreatingNewPolicyYear = false;
      if (selectLastPolicyContractVersion) {
        this.onSelectPolicyContractVersion(pc.versions[pc.versions.length - 1]);
      }
    });
  }

  onSelectClient(client: CompanySimpleDto) {
    this.selectedPolicyContractVersion.client = client;
    delete this.selectedPolicyContractVersion.guarantors;
    if (
      this.policyContractTypeSet &&
      client !== undefined &&
      !(this.selectedPolicyContractVersion.id && this.selectedPolicyContractVersion.id > 0)
    ) {
      this.getInitialContractVersion(this.selectedPolicyContractVersion.contractType.id);
    }
  }

  fixedBlockHidden() {
    return !(this.policyContractTypeSet && this.selectedPolicyContractVersion.client);
  }

  onPrintSelected(template: TemplateSimpleDto) {
    this.routerService.toDocumentDetailsNew(template.id, this.selectedPolicyContractVersion.id);
  }

  onChangePolicyVersion(policyContractVersion: PolicyContractVersionDto) {
    this.onSelectPolicyContractVersion(policyContractVersion);
  }

  onChangePolicyYear(policyContract: PolicyContractBaseDto) {
    this.onSelectPolicyContract(policyContract, true);
  }

  setPolicyYear(year: number) {
    if (+year <= this.masterPolicyContract.policyContracts.length) {
      this.onChangePolicyYear(this.masterPolicyContract.policyContracts.find((item) => item.policyYear === +year));
    }
  }

  private loadWordingTemplates() {
    this.templateService.getWordingTemplates(this.selectedPolicyContractVersion).subscribe((result) => {
      this.wordingTemplates = result.reduce((acc, v) => acc.concat(v, [])).sort((a, b) => (a.id < b.id ? 1 : -1));
    });
  }

  isSectionVisible(viewSection: PolicyContractViewSection, defaultVisibility = false) {
    const pcv = this.selectedPolicyContractVersion;
    return (
      pcv &&
      pcv.contractType &&
      pcv.contractType.id &&
      this.policyContractViewService.isSectionVisible(pcv.contractType.id, viewSection, defaultVisibility)
    );
  }

  public policyTypeSwitch(): number {
    if (this.selectedPolicyContractVersion && this.selectedPolicyContractVersion.contractType) {
      return this.selectedPolicyContractVersion.contractType.id;
    }
    return 0;
  }

  get credendoAnyNewActionPossible() {
    return this.credendoAnyNewActionPossible_flag;
  }

  createUnlockTaskButtonVisible() {
    return (
      this.selectedPolicyContractVersion &&
      this.selectedPolicyContractVersion.status &&
      this.selectedPolicyContractVersion.status.id === PolicyContractVersionStatus.ACTIVATED_LOCKED
    );
  }

  createLockTaskButtonVisible() {
    return this.selectedPolicyContractVersion?.status?.id === PolicyContractVersionStatus.ACTIVATED;
  }

  createUnlockTask() {
    this.createTask(
      TaskType.POLICY_UNLOCK,
      'policy.details.unlockTask.creationNoticeSuccess',
      'policy.details.unlockTask.creationNoticeError'
    );
  }

  createLockTask() {
    this.createTask(
      TaskType.POLICY_LOCK,
      'policy.details.lockTask.creationNoticeSuccess',
      'policy.details.lockTask.creationNoticeError'
    );
  }

  private createTask(taskType: TaskType, msgSuccess: string, msgError: string) {
    this.policyContractService.createTask(this.selectedPolicyContractVersion.policyContract.id, taskType).subscribe({
      next: (task) => {
        this.growlService.notice(msgSuccess, null, {description: task.description});
      },
      error: () => {
        this.growlService.error(msgError);
      },
    });
  }

  private updateModel() {
    this.selectedPolicyContractVersion.reinsuranceMode = this.form.get('reinsuranceMode')
      ? this.form.get('reinsuranceMode').value
      : undefined;
    this.selectedPolicyContractVersion.frontingTreaty = this.form.get('frontingTreaty')
      ? this.form.get('frontingTreaty').value
      : undefined;
    if (
      !this.selectedPolicyContractVersion.premiumInstalments &&
      this.selectedPolicyContractVersion.premiumInstalementCalendar
    ) {
      this.selectedPolicyContractVersion.premiumInstalementCalendar = undefined;
    }
  }

  get terminationPossible() {
    return this.termination_flag;
  }

  private calculateCanBeTerminated() {
    this.termination_flag = false;
  }

  termination(): void {
    if (!this.selectedPolicyContractVersion || !this.selectedPolicyContractVersion.id) {
      return;
    }
    // this.serverErrors = null;
    this.inProgress = true;
    // this.readonly = false;on
    this.policyContractVersionService.termination(this.selectedPolicyContractVersion.policyContract.id).subscribe(
      (newPCV) => {
        this.setPolicyContractVersion(newPCV);
      },
      (error) => this.handleServerError(error),
      () => this.afterNewAnnex()
    );
  }

  versionEditable(): boolean {
    const changeStateAvailableOrNewVersion = this.changeStateAvailable() || !this.selectedPolicyContractVersion.id;
    return changeStateAvailableOrNewVersion && !this.inStatus(PolicyContractVersionStatus.ACTIVATED_LOCKED);
  }

  onEdit() {
    super.onEdit();
    this._presentationMode = false;
    this.serverErrors = null;
    this.policyContractViewService.reportingPeriodsEditable = true;
    this.readonly = this.inStatus(PolicyContractVersionStatus.ACTIVATED_LOCKED); // CR;
  }

  get inquiryName(): String {
    if (this.selectedPolicyContractVersion.inquiry.policyInquiry.inquiryType === 'POLICY_ANNEX') {
      return this.translateService.instant('inquiry.annexName');
    } else if (this.selectedPolicyContractVersion.inquiry.policyInquiry.inquiryType === 'RENEWAL_INQUIRY') {
      return this.translateService.instant('inquiry.renewalName');
    }
    return this.translateService.instant('inquiry.name');
  }

  get inStatusTerminated() {
    return this.selectedPCVInOneOfStatuses(POLICY_CONTRACT_REQUEST_OR_TERMINATION_REQUEST_STATUSES);
  }

  private inStatus(statusId: PolicyContractVersionStatus): boolean {
    return (
      this.selectedPolicyContractVersion &&
      this.selectedPolicyContractVersion.status &&
      this.selectedPolicyContractVersion.status.id === statusId
    );
  }

  private selectedPCVInOneOfStatuses(statuses: PolicyContractVersionStatus[]): boolean {
    return <boolean>statuses.reduce((prev, curr) => prev || this.selectedPCVInStatus(curr), undefined);
  }

  get rejectTypeRegexp(): RegExp {
    const notFirstVersion =
      this.selectedPolicyContractVersion && this.selectedPolicyContractVersion.versionNumber !== 1;
    if (notFirstVersion) {
      return /^(?:CANCELLATION_DOCUMENT)$/;
    } else {
      return /^(?:CANCELLATION_PAYMENT|CANCELLATION_DOCUMENT)$/;
    }
  }

  protected generateCoInsReport() {
    let params = new HttpParams();
    params = params.append('policycontractid', this.selectedPolicyContractVersion.policyContract.id + '');
    this.serverErrors = undefined;
    this.businessReportService.generate(103, 'Co-ins report.xlsx', params, (errorMsg) =>
      this.downloadErrorCallback(errorMsg)
    );
  }

  openUploadSplitWindow() {
    const confirmationPromise: Promise<boolean> = this.addToSplitDialog.open('searchView.policy.uploadToSplit');
  }

  validateCeaserIds() {
    const cesarIds = this.coInsuredsTempData.map((x) => x.insuredCesarId).filter(Boolean);
    const cesarDuplicateids = cesarIds.filter((id, i) => cesarIds.indexOf(id) !== i);
    this.isDuplicateIdExists = cesarDuplicateids.length > 0 ? true : false;
  }

  saveInsuredData() {
    if (this.coInsuredsTempData.length > 0) {
      const client = this.findById(this.selectedPolicyContractVersion.client.id);
      if (client !== undefined) {
        this.selectedPolicyContractVersion.clientTurnoverDomestic = client?.domestic;
        this.selectedPolicyContractVersion.clientTurnoverExport = client?.export;
        this.selectedPolicyContractVersion.clientTaxCountry = client?.taxCountry;
        this.selectedPolicyContractVersion.clientTurnover = client?.total;
      }

      for (let i = 0; i < this.selectedPolicyContractVersion.subinsured.length; i++) {
        const subInsuredData = this.findById(this.selectedPolicyContractVersion.subinsured[i].company.id);
        if (subInsuredData !== undefined) {
          this.selectedPolicyContractVersion.subinsured[i].insuredTurnover = subInsuredData?.total;
          this.selectedPolicyContractVersion.subinsured[i].insuredTurnoverDomestic = subInsuredData?.domestic;
          this.selectedPolicyContractVersion.subinsured[i].insuredTurnoverExport = subInsuredData?.export;
          this.selectedPolicyContractVersion.subinsured[i].taxCountry = subInsuredData?.taxCountry;
        }
      }
      this.coInsuredsTempData = [];
    }
  }

  clearInsuredData() {
    this.coInsuredsTempData = [];
    this.isDuplicateIdExists = false;
  }

  findById(cesarId: number) {
    return this.coInsuredsTempData.find((obj) => obj.insuredCesarId === cesarId);
  }

  emitCountryTurnoverChanged() {}
}

export interface CopyPastedTurnoverData {
  insuredName: string;
  insuredCountry: string;
  insuredCesarId: number;
  taxCountry: DictionaryBaseDto;
  total: number;
  domestic: number;
  export: number;
  domesticPercentage: number;
  exportPercentage: number;
}
